import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiMembersPrivatePersonalMemosIndexRequestType,
  ApiMembersPrivatePersonalMemosIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ApiMembersPrivatePersonalMemosIndexRequestType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiMembersPrivatePersonalMemosIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersPrivatePersonalMemosIndexResponseType>(
      "/api/members/private_personal_memos",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiMembersPrivatePersonalMemosIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisMembersPrivatePersonalMemosIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiMembersPrivatePersonalMemosIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisMembersPrivatePersonalMemosIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
